export default __webpack_public_path__ + "static/media/Summoner's Gauntlets of Imperial Assent.dc982442.jpg";